import BaseService from "./BaseService";

class ScriptInstanceService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/payment/paymentGateway/getHostedCheckoutUrl?skipAuthentication=true&locale=fr_FR&countryCode=Fr";
	}

	executeScriptGET(data) {
		let url = this.serviceUrl + `${data}`;
		return this.opencellAPI.callApi(url);
	}
}

const scriptInstanceService = new ScriptInstanceService();

export default scriptInstanceService;



// WEBPACK FOOTER //
// ./src/opencell/services/ScriptInstanceService.js